import React from 'react'
import HeaderOne from '../../common/header/HeaderOne'
import CustomFooter from "../../elements/CustomFooter/CustomFooter";
import Copyright from '../../common/footer/Copyright'
import './style.css'
import SEO from '../../common/SEO';

function CRMDev() {
  return (
    <>
      <SEO title="About Us" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent66" />
        <div className="slider-area slider-style-1 height-380 bg_image" data-black-overlay="1" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner/1ec998fc6466563c4459d4fc44088214db6cabe8-1381x548.jpg)` }}>
        </div>
        <div className='main_container_for_services'>
          <div className='inner_container_for_services'>
            <div style={{ height: '8px', width: '60px', background: '#00C896', marginBottom: '2rem' }}></div>            <h1>Customer Relationship Management Solutions</h1>
            <p style={{ marginBottom: '3.5rem' }}>Maximize profitability, improve efficiency, and enhance customer satisfaction with client-focused CRM solutions.</p>
            <h3>Customer Relationship Management Solutions</h3>
            <p style={{ marginBottom: '3.5rem' }}>A CRM software isn't simply another management tool, it is a way to completely transform and streamline the way you collect, organize and manage client data. Imagine if your team was easily able to access all information regarding a client - previous sales, their individual preferences, history, emails, notes - and could leverage that data into enhanced client relationships, improved customer retention, and increased sales. And that only scratches the surface of what a CRM software can do.</p>
            <p style={{ marginBottom: '3.5rem' }}>Bringing in new customers is just as important as retaining current ones, and a CRM software can help optimize that process as well, thanks to improved analytics and tailored marketing automation. With an organized system of client information stored in an accessible online environment, including interactions with your website and what emails have been opened, you can create completely bespoke marketing and sales strategies that are professional and personal.</p>
            <h3>Custom Apps Done the Right Way</h3>
            <p style={{ marginBottom: '3.5rem' }}>We specialize in designing, developing, deploying, and optimizing web-based and desktop-based business applications that are customized and highly functional. These custom apps include:</p>
            <h3>Desktop software for business</h3>
            <ul style={{ listStyleType: 'square' }}>
              <li>Custom applications for client servers</li>
              <li>Various utilities for software</li>
              <li>Graphic processing applications </li>
            </ul>
            <p style={{ marginBottom: '3.5rem' }}>If you are looking to build a custom app, contact us for a consultation.</p>
          </div>
          <div className='thirdy_container_for_services'>
            <img src={`${process.env.PUBLIC_URL}/images/banner/1563c42ea2cc558e910dd24b1ab5a482b0e2ca29-581x552.jpg`} />
          </div>
        </div>
      </main>
      <CustomFooter />
    </>
  )
}

export default CRMDev